/**
 * Asynchronously loads the component for GuestChatBot
 */

import React from "react";
import loadable from "utils/loadable";
import ClipLoader from "react-spinners/ClipLoader";

export default loadable(() => import("./GuestChatBot"), {
  fallback: (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <ClipLoader size={100} color={"#4f2d7f"} loading={true} />
    </div>
  ),
});
